import { Transition } from '@headlessui/react'
import React from 'react'

export const TransitionSlideUp = ({ children, show, enterTime, className, leaveTime }) => {
  return (
    <Transition
      show={show}
      enter={`transform transition duration-${enterTime} ease-out`}
      enterFrom="opacity-0 translate-y-full"
      enterTo="translate-y-0 opacity-100"
      // Unable get this working reliably with React Router
      // leave={`transform transition duration-${leaveTime} ease-out`}
      // leaveFrom="opacity-100 translate-y-0"
      // leaveTo="opacity-0 translate-y-full"
      className={className}
    >
      {children}
    </Transition>
  )
}
